'use es6';

import { createSelector } from 'reselect';
import { getUserId } from './auth';
export const getReviewsListRequestState = state => state.reviews.listRequestState;
export const getReviewsList = state => state.reviews.list;
export const getReviewsTotal = state => state.reviews.total;
export const getReviewStatsRequestState = state => state.reviews.statsRequestState;
export const getReviewStats = state => state.reviews.stats;
export const getReviewFilters = state => state.reviews.filters;
export const getReviewabilityRequestState = state => state.reviews.reviewabilityRequestState;
export const getReviewability = state => state.reviews.reviewability;
export const getReviewSubmitted = state => state.reviews.reviewSubmitted; // Selector factory enables us to pass props into useSelector and maintain memoization

export const makeGetUserMarkedHelpfulSelector = () => createSelector([getReviewsList, getUserId, (_, reviewId) => reviewId], (reviews, userId, reviewId) => {
  const review = reviews.find(rev => rev.get('id') === reviewId);
  return review && review.get('attributes').some(attr => attr.get('userId') === userId && attr.get('helpful'));
});